import React, { useState } from 'react';
import { locales } from '../../../translations/locales';
import { _$ } from '../../../controllers/dom';
import Entrie from './Entrie';

const FollowUp = (props) => {
    const { locale, mission, ModuleRP } = props;
    const [addLogBook, setAddLogBook] = useState(false);
    const [showHistory, setShowHistory] = useState(false);

    const validateLogBook = () => {
        ModuleRP.addLogBook({ entrie: _$('logBookEntries').value, number: mission.number });
        setAddLogBook(false);
    };

    return (
        <div className='alert alert-secondary'>
            <h6>
                {locales[locale].sgo.logBook}
                {
                    !addLogBook ? (
                        <button type='button' className='btn btn-sm btn-success pt-0 pb-0 pl-4 pr-4 m-1' onClick={() => setAddLogBook(!addLogBook)}>
                            {locales[locale].config.add}
                        </button>
                    ) : <button type='button' className='btn btn-sm btn-danger pt-0 pb-0 pl-4 pr-4 m-1' onClick={() => setAddLogBook(!addLogBook)}>
                        {locales[locale].cancel}
                    </button>
                }
                {
                    addLogBook ? (
                        <>
                            <textarea
                                className='form-control m-1'
                                id='logBookEntries'
                                rows='3'
                            />
                            <div className='text-right'>
                                <button type='button' className='btn btn-sm btn-success pt-0 pb-0 pl-4 pr-4 m-1' onClick={validateLogBook}>
                                    {locales[locale].validate}
                                </button>
                            </div>
                        </>
                    ) : null
                }
            </h6>
            {
                mission.logBook.map((logBook, index) => (
                    <Entrie key={index} entrie={logBook} locale={locale} />
                ))
            }
            <hr className={`m-1 bg-secondary`} />
            {
                !showHistory ? (
                    <button type='button' className='btn btn-sm btn-secondary pt-0 pb-0 pl-4 pr-4 m-1' onClick={() => setShowHistory(!showHistory)}>
                        {locales[locale].sgo.showHistory}
                    </button>
                ) : (
                    <button type='button' className='btn btn-sm btn-secondary pt-0 pb-0 pl-4 pr-4 m-1' onClick={() => setShowHistory(!showHistory)}>
                        {locales[locale].sgo.hideHistory}
                    </button>
                )
            }
            {
                showHistory &&
                mission.history.map((history, index) => (
                    <Entrie key={index} entrie={history} locale={locale} />
                ))
            }
        </div>
    );
};

export default FollowUp;
